














































import { Component, Vue } from 'vue-property-decorator';
import SocialMediaIcons from '@/shared/components/SocialMediaIcons.vue';

@Component({
    components: {
        SocialMediaIcons
    },
})
export default class Footer extends Vue {
    private social = [
        {
            name: 'Facebook',
            icon: 'fab fa-facebook',
            link: ' https://www.facebook.com/golagolsupport/'
        },
        {
            name: 'Twitter',
            icon: 'fab fa-twitter',
            link: 'https://www.instagram.com/golagolsupport/'
        },
        {
            name: 'Instagram',
            icon: 'fab fa-instagram',
            link: 'https://twitter.com/GolaGolFantasy'
        }
    ]
}
